import { AppRoute, news } from "../../constants";
import "./NewsItem.scss";
import { usePageContext } from "shared/hooks/usePageContext.jsx";
import Layout from "../../components/mainPage/Layout";
import StandartArticle from "shared/components/StandartArticle";
import { NotFoundContent } from "shared/components/NotFoundContent";

export function Page() {
    const ctx = usePageContext();
    const newsId = ctx?.pageProps?.id;
    const item = news.find(n => n.id == newsId);

    if (!item) {
        return <Layout><NotFoundContent /></Layout>
    }
    return (
        <Layout>
            <main className="container my-4">
                <div className="article-container">
                    <a
                        href={AppRoute.News}
                        className="link mb-4 text-accent"
                        style={{ alignSelf: "flex-start" }}
                    >
                        Новости
                    </a>
                    <h3 className="mt-4">{item.title}</h3>
                    <StandartArticle
                        description={item.page}
                    />
                    <div className="news-item_links d-flex justify-content-between">
                        {item.id !== 1 ? (
                            <a
                                href={`/newsitem/${item.id - 1}`}
                                className="link mr-4 text-accent"
                            >
                                Предыдущая
                            </a>
                        ) : (
                            <div className="mr-4 news-item__link_disabled">
                                Предыдущая
                            </div>
                        )}
                        {item.id !== news.length ? (
                            <a
                                href={`/newsitem/${item.id + 1}`}
                                className="ml-3 link text-accent"
                            >
                                Следующая
                            </a>
                        ) : (
                            <div className="ml-3 news-item__link_disabled">
                                Следующая
                            </div>
                        )}
                    </div>
                </div>
            </main>
        </Layout>
    );
}

export const meta = {
    title: 'Новости',
    description: ''
}